/**
 * JSON Web  Token widget
 */
export default class JWT {
  install(Vue) {
    Vue.prototype.$jwt = {
      /**
       * 删除登录帐号
       */
      remove() {
        Vue.prototype.$storage.remove('user');
      },

      /**
       * Store user object to storage
       * @param  {String} token jwt
       * @return {Object} playload data of jwt
       */
      save(token) {
        let playload = token.split('.')[1];
        playload = new Buffer(playload, 'base64').toString();
        playload = JSON.parse(playload);

        Vue.prototype.$storage.setJSON('user', Object.assign(playload, {
          token,
        }));

        return playload;
      },

      /**
       * 获取存储的用户对象；如果token已过期则从storage里面删除
       * @return {Object} 无效或不存在返回null；否则返回user对象
       */
       user() {
        const stroage = Vue.prototype.$storage;
        let user = stroage.getJSON('user');
        if (user == null) {
          return user;
        }

        const now = new Date();
        if (user.exp < Math.floor(now.getTime() / 1000)) {
          stroage.remove('user');
          return null;
        }

        return user;
      },
    }
  }
}
